import { render, staticRenderFns } from "./SaveList.vue?vue&type=template&id=dc91aef6&scoped=true&"
import script from "./SaveList.vue?vue&type=script&lang=js&"
export * from "./SaveList.vue?vue&type=script&lang=js&"
import style0 from "./SaveList.vue?vue&type=style&index=0&id=dc91aef6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc91aef6",
  null
  
)

export default component.exports